<!--
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2023-04-20 15:51:05
 * @LastEditors: fangzhi fangzhi@vivo.com
 * @LastEditTime: 2023-10-10 20:16:07
-->
<template>
  <div class="store-delivery" v-show="showModel">
    <v-list-view :right-icon="isSupport ? 'arrow-right-v3' : ''" name="门店" @click="openStoreInfo">
      <div class="store-address">
        <span
          class="support"
          v-if="isSupport"
          v-text="shopName"
          v-track="{
            act: 'show',
            params: {
              event_id: '081|074|02|077',
              arrive_type: deliveryTime,
              name: shopName,
              storeid: storeInfo.shopCode,
              result: deliveryTime ? '1' : '0',
              result_pickup: selfPickUpTime ? '1' : '0',
              sku_id: skuId
            }
          }"
        ></span>
        <span
          class="unsupport"
          v-else
          v-track="{
            act: 'show',
            params: {
              event_id: '081|074|02|077',
              arrive_type: '',
              name: '',
              storeid: '',
              result: unSuportCode.toString(),
              result_pickup: unSuportCode.toString(),
              sku_id: skuId
            }
          }"
        >
          {{ unSupportMessage }}
        </span>
      </div>
      <div class="detail" v-if="isSupport">
        <span class="label" v-if="deliveryTime">{{ deliveryTime }}</span>
        <span class="label" v-if="selfPickUpTime">{{ selfPickUpTime }}</span>
        <span class="distance" v-text="`距离${formatDistance(distance)}`"></span>
      </div>
    </v-list-view>
    <StoreInfoPopup v-if="storeInfo" :isShow="isShow" @close="close" :storeInfo="storeInfo" :skuId="skuId" @showDesc="showDesc" />
    <v-os-popup
      :show="isShowTips"
      @close="closeTips"
      :title="tipTitle"
      :footerShow="false"
      class="vPopup"
      container="body"
    >
      <div class="content-desc">{{ ruleDetail }}</div>
    </v-os-popup>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import StoreInfoPopup from 'components/store-info-popup'
import env from '@/utils/clientEnv'
import { getStoreInfo } from '../../index/api.js'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'StoreDelivery',
  components: {
    StoreInfoPopup
  },
  data() {
    //这里存放数据
    return {
      isLowAndroid: env.isLowAndroid,
      isStoreSupport: false,
      isShow: false,
      isShowStoreDelivery: false,
      hasDetail: false, //是否有详细地址或者经纬度信息
      isSupport: false,
      // unSupportMessage: '',
      storeInfo: null,
      shopName: '',
      deliveryTime: '',
      selfPickUpTime: '', // 门店自提
      distance: '',
      unSuportCode: [],
      submitFlag: true,
      isShowTips: false
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState('detailv3', ['spuInfo', 'latitude', 'longitude', 'addressData', 'selectParams', 'isLBS']),
    ...mapGetters('detailv3', [
      'spuId',
      'skuId',
      // 商品类型，1：手机 2：配件 3：服务 4：虚拟商品
      'goodsType',
      // 定金预售
      'isDepositBuy',
      // 全款预定
      'isFullPayBuy',
      // 拼购
      'isGroup',
      // 会员先享购
      'isVipFirstBuy',
      // 是否展示送至模块
      'isShowLogistics',
      // 套餐信息
      'currentSuiteInfo',
      // 赠品信息
      'commodityGifts'
    ]),
    // 判断是否为套餐
    isSuite() {
      return Boolean(this.currentSuiteInfo?.id)
    },
    // 赠品是否存在服务类型
    hasServiceGift() {
      // TODO:对赠品进行判断，看是否存在服务赠品
      let services = this.commodityGifts?.filter(el => {
        return el.commodityTypeId == 3
      })
      return Boolean(services.length)
    },
    unSupportMessage() {
      if (this.unSuportCode.length) {
        let code = this.unSuportCode[this.unSuportCode.length - 1]
        return this.codeMessage[code]
      } else {
        return ''
      }
    },
    tipTitle() {
      return this.storeInfo?.ruleTitle ? this.storeInfo.ruleTitle : ''
    },
    ruleDetail() {
      return this.storeInfo?.ruleDetail ? this.storeInfo.ruleDetail : ''
    },
    showModel() {
      if (this.isLBS) {
        return this.isShowStoreDelivery && this.isStoreSupport
      } else {
        return this.isShowStoreDelivery && this.hasDetail && this.isShowLogistics && this.isStoreSupport
      }
    },
    codeMessage() {
      // LBS和收货地址逻辑方案
      const txt = this.isLBS ? '服务' : '闪送'
      // 这里的code码与埋点对应
      return {
        2: '选择套餐后不支持门店' + txt,
        3: '选择服务后不支持门店' + txt,
        4: '选择免费雕刻服务后不支持门店' + txt,
        5: '当前版本/颜色的商品暂不支持门店' + txt,
        7: '选择多种商品暂不支持门店' + txt
      }
    }
  },
  //监控data中的数据变化
  watch: {
    addressData: {
      handler(value) {
        // 判断商品是否支持门店
        this.checkProductInfo()
        if (this.isShowStoreDelivery && this.checkSuiteAndService()) {
          this.submitFlag = true
          if (value?.isFromPosition || value?.detailAddress) {
            this.hasDetail = true
            this.getStoreInfoByDetail()
          } else {
            this.hasDetail = false
            // 地址不支持
            this.$track({
              event_id: '081|074|02|077',
              arrive_type: '',
              name: '',
              storeid: '',
              result: '6',
              result_pickup: '6',
              sku_id: this.skuId
            })
          }
        }
      },
      immediate: true
    },
    isLBS: {
      handler(val) {
        if (val) {
          this.checkProductInfo()
          this.getStoreInfoByDetail()
        }
      },
      immediate: true
    },
    'selectParams.laser': {
      handler(newValue, oldVal) {
        // 判断镭雕
        this.submitFlag = true
        if (newValue) {
          if (!this.unSuportCode.includes('4')) {
            this.unSuportCode.push('4')
          } else {
            this.unSuportCode.splice(this.unSuportCode.indexOf('4'), 1)
            this.unSuportCode.push('4')
          }
        } else {
          if (this.unSuportCode.includes('4')) {
            this.unSuportCode.splice(this.unSuportCode.indexOf('4'), 1)
          }
        }
      }
    },
    'selectParams.currentSuite': {
      handler(newValue, oldVal) {
        // 判断套餐
        this.submitFlag = true
        if (newValue?.id && newValue.id != oldVal.id) {
          if (!this.unSuportCode.includes('2')) {
            this.unSuportCode.push('2')
          } else {
            this.unSuportCode.splice(this.unSuportCode.indexOf('2'), 1)
            this.unSuportCode.push('2')
          }
        } else if (!newValue?.id && oldVal.id) {
          if (this.unSuportCode.includes('2')) {
            this.unSuportCode.splice(this.unSuportCode.indexOf('2'), 1)
          }
        }
      }
    },
    'selectParams.service': {
      handler(newValue, oldVal) {
        // 判断服务
        this.submitFlag = true
        if (Object.keys(newValue).length) {
          if (!this.unSuportCode.includes('3')) {
            this.unSuportCode.push('3')
          } else {
            this.unSuportCode.splice(this.unSuportCode.indexOf('3'), 1)
            this.unSuportCode.push('3')
          }
        } else {
          if (this.unSuportCode.includes('3')) {
            this.unSuportCode.splice(this.unSuportCode.indexOf('3'), 1)
          }
        }
      }
    },
    'selectParams.additionCommodity': {
      handler(newValue, oldVal) {
        // 判断是否存在加购商品
        this.submitFlag = true
        if (newValue.length) {
          if (!this.unSuportCode.includes('7')) {
            this.unSuportCode.push('7')
          } else {
            this.unSuportCode.splice(this.unSuportCode.indexOf('7'), 1)
            this.unSuportCode.push('7')
          }
        } else {
          if (this.unSuportCode.includes('7')) {
            this.unSuportCode.splice(this.unSuportCode.indexOf('7'), 1)
          }
        }
      }
    },
    unSuportCode: {
      handler(newVal) {
        if (this.submitFlag) {
          if (newVal.length == 1 && newVal[0] == '5') {
            this.paramsChange(true)
          } else {
            this.paramsChange(false)
          }
        }
      }
    },
    skuId: {
      handler() {
        // 判断商品是否支持门店闪送
        this.checkProductInfo()
        this.submitFlag = true
        if (this.isShowStoreDelivery && this.checkSuiteAndService()) {
          // 切换版本和颜色
          if (!this.unSuportCode.includes('5')) {
            this.unSuportCode.push('5')
          } else {
            this.unSuportCode.splice(this.unSuportCode.indexOf('5'), 1)
            this.unSuportCode.push('5')
          }
        }
      }
    }
  },
  //方法集合
  methods: {
    ...mapActions('detailv3', ['savePreFocusElByEvent']),
    showDesc() {
      this.isShowTips = true
    },
    closeTips() {
      this.isShowTips = false
    },
    paramsChange(flag) {
      if (this.unSuportCode.length && !flag) {
        this.isSupport = false
        this.storeInfo = null
      }
      if (!this.unSuportCode.length || flag) {
        if (this.addressData?.detailAddress || this.addressData?.isFromPosition || this.isLBS) {
          this.hasDetail = true
          this.getStoreInfoByDetail()
        } else {
          this.hasDetail = false
        }
      }
    },
    checkSuiteAndService() {
      if (
        this.selectParams.currentSuite?.id ||
        this.selectParams.laser ||
        Object.keys(this.selectParams.service).length
      ) {
        return false
      } else {
        return true
      }
    },
    formatDistance(value) {
      if (value < 1000) {
        return value + 'm'
      } else {
        return (value / 1000).toFixed(1) + 'km'
      }
    },
    checkProductInfo() {
      if (
        this.goodsType == 3 ||
        this.goodsType == 4 ||
        this.isDepositBuy ||
        this.isFullPayBuy ||
        this.isGroup ||
        this.isVipFirstBuy
      ) {
        this.isShowStoreDelivery = false
      } else {
        this.isShowStoreDelivery = true
      }
      // 套餐商品链接初始化处理
      if (this.isSuite && !this.unSuportCode.includes('2')) {
        this.isSupport = false
        this.unSuportCode.push('2')
      }
    },
    // 根据坐标 or 详细地址获取门店信息
    getStoreInfoByDetail() {
      if (this.submitFlag) {
        this.submitFlag = false
        if (!this.showModel) {
          this.isStoreSupport = false
        }
        let params = {
          skuId: this.skuId,
          spuId: this.spuId,
          count: 1,
          gitfServiceFlag: this.hasServiceGift, // 赠品中包含服务时，需要查询门店自提（自提会过滤掉赠品）
          province: this.addressData?.province,
          city: this.addressData?.city,
          district: this.addressData?.area,
          detailAddress: this.addressData?.detailAddress,
          isSwitchAddresses: this.addressData?.isSwitchAddresses || 0, // 是否手动切换地址，默认优先经纬度，手动切换则优先详细地址
          longitude: this.longitude,
          latitude: this.latitude
        }
        getStoreInfo(params)
          .then(res => {
            if (res?.support) {
              this.isStoreSupport = true
              if (this.isSuite) {
                this.isSupport = false
              } else {
                this.isSupport = true
                this.unSuportCode = []
              }
              this.storeInfo = res
              this.shopName = res.shopName
              this.deliveryTime = res.deliveryTime
              this.selfPickUpTime = res.selfPickUpTime
              this.distance = res.distance
            } else {
              this.isSupport = false
              if (!this.showModel) {
                this.unSuportCode = []
                this.isStoreSupport = false
              } else {
                if (this.unSuportCode.length) {
                  this.isStoreSupport = true
                } else {
                  this.isStoreSupport = false
                }
              }
            }
          })
          .catch(e => {
            this.isSupport = false
            if (!this.showModel) {
              this.unSuportCode = []
              this.isStoreSupport = false
            } else {
              if (this.unSuportCode.length) {
                this.isStoreSupport = true
              } else {
                this.isStoreSupport = false
              }
            }
          })
      }
    },
    openStoreInfo(e) {
      if (this.storeInfo && !this.unSuportCode.length) {
        this.isShow = true
        this.savePreFocusElByEvent(e)
        this.$track({
          event_id: '081|074|01|077',
          arrive_type: this.storeInfo.deliveryTime,
          name: this.storeInfo.shopName,
          storeid: this.storeInfo.shopCode,
          tag_type: this.storeInfo.support,
          sku_id: this.skuId
        })
      }
    },
    close() {
      this.isShow = false
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="scss" src="./index.scss" />
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
